module.exports = "<div class=\"notification {{'notification-' + notify.type}}\" ng-if=\"notify.visible\">\n  <div class=\"notification-backdrop\" ng-click=\"notify.hide()\"></div>\n  <div class=\"notification-view\">\n    <div class=\"notification-close\" ng-click=\"notify.hide()\"></div>\n    <div class=\"notification-message\">{{notify.message}}</div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/lib/ionic1.x-common/services/alert/notification.html
// module id = 93
// module chunks = 0